import { handleActions } from 'redux-actions'
import * as actions from '@/store/action/tool/compensate'
const ticketReducer = handleActions({
    [actions.resetFetchState]: (state, action) => ({
        ...state,
        ...action.payload
    }),

    // 清除原渠道退款支付详情
    [actions.clearTravelRefundDetail]: (state, action) => {
        return {
            ...state,
            payment : [],
            records: [],
        }
    },

    // 获取原渠道退款支付详情
    [actions.getPassengerTravelRefundDetailSuccess]: (state, action) => {
        let { payment, records } = action.payload.data || {}
        // 重组 records  
        let newRecords = []
        // eslint-disable-next-line array-callback-return
        records?.map(re => {
            // eslint-disable-next-line array-callback-return
            re.channels.map(res => {
                let newData = { ...re, ...res }
                delete newData.channels
                newRecords.push(newData)
            })
        })

        return {
            ...state,
            payment,
            records: newRecords,
            getPassengerTravelRefundDetailSuccess: true
        }
    },
    // 获取业务类型
    [actions.getBusinessTypesByPageSuccess]: (state, action) => {
        return {
            ...state,
            businessTypesByPage: action.payload?.list || [],
            getBusinessTypesByPageSuccess: true
        }
    },
    // 获取可用优惠券
    [actions.getCouponConfigureSuccess]: (state, action) => {
        // 数据结构处理 price展示单位元（分 => 元）
        let couponConfigure = action.payload?.couponConfigure || []
        let newCoupon = couponConfigure.map((re) => {
            let { id, price } = re
            return { id, price: price / 100 }
        })
        return {
            ...state,
            couponConfigure: newCoupon,
            getCouponConfigureSuccess: true
        }
    },
}, actions.initStateData)

export default ticketReducer
